import VueCharts from "vue-chartjs";
import { Bar, Line } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    data: {},
    labels: {},
    yAxisLabel: {
      default: "ค่า",
    },
    xAxisLabel: {
      default: "แท่ง",
    },
  },

  mounted() {
    // Overwriting base render method with actual data.
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: this.xAxisLabel,
            backgroundColor: "rgba(158, 118, 180,1)",
            data: this.data,
          },
        ],
      },
      {
        title: {
          display: false,
          text: "",
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              scaleLabel: {
                display: true,
                labelString: this.yAxisLabel,
              },
            },
          ],
          xAxes: [
            {
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1,
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
      }
    );
  },
};
